import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './MenuBar.css';
import logo from '../components/Logo2.jpg'; // Ensure these paths are correct

const MenuBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
  const isActive = (path) => location.pathname === path;

  // Optional: Prevent body scroll when menu is open on mobile
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    return () => (document.body.style.overflow = 'auto');
  }, [isOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="Minerva-Precision" className="logo" />
        </Link>
      </div>

      <div className={`navbar-links ${isOpen ? 'active' : ''}`}>
        <Link to="/" onClick={closeMenu} className={isActive('/') ? 'active' : ''}>Home</Link>
        <Link to="/about" onClick={closeMenu} className={isActive('/about') ? 'active' : ''}>About Us</Link>
        <Link to="/services" onClick={closeMenu} className={isActive('/services') ? 'active' : ''}>Services</Link>
        <Link to="/products" onClick={closeMenu} className={isActive('/products') ? 'active' : ''}>Infrastructure</Link>
        <Link to="/client" onClick={closeMenu} className={isActive('/client') ? 'active' : ''}>Clients</Link>
        <Link to="/careers" onClick={closeMenu} className={isActive('/careers') ? 'active' : ''}>Careers</Link>
        <Link to="/contact" onClick={closeMenu} className={isActive('/contact') ? 'active' : ''}>Contact Us</Link>
      </div>

      <div className="navbar-toggle" onClick={toggleMenu}>
        {isOpen ? <span className="close">&times;</span> : (
          <>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </>
        )}
      </div>
    </nav>
  );
};

export default MenuBar;